import DupontButton from './DupontButton';

export * from './DupontButton';

export default DupontButton;
